var _path, _path2, _path3;

var _excluded = ["width", "height", "originalSize", "top", "bottom", "left", "right"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var toUnit = function toUnit(v) {
  return !v || /^([0-9]+(px|em|rem|%)|auto)/.test(v) ? v : v + 'px';
};

var SvgWarningIconTriangle = function SvgWarningIconTriangle(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '35px' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '35px' : _ref$height,
      originalSize = _ref.originalSize,
      top = _ref.top,
      bottom = _ref.bottom,
      left = _ref.left,
      right = _ref.right,
      rest = _objectWithoutProperties(_ref, _excluded);

  var hasStyle = !!top || !bottom || !!right || !!left;
  var style = hasStyle ? {
    marginTop: toUnit(top),
    marginBottom: toUnit(bottom),
    marginRight: toUnit(right),
    marginLeft: toUnit(left)
  } : {};
  var props = originalSize ? _objectSpread(_objectSpread({}, rest), {}, {
    style: style
  }) : _objectSpread(_objectSpread({}, rest), {}, {
    style: style,
    width: toUnit(width),
    height: toUnit(height)
  });
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F9E2B6",
    stroke: "#DEB567",
    strokeWidth: 1.5,
    d: "M26.205 9.528c2.784-4.871 9.806-4.871 12.59 0l22.214 38.875c2.762 4.833-.728 10.847-6.294 10.847h-44.43c-5.566 0-9.056-6.014-6.294-10.847L26.205 9.528Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCF5D7",
    d: "M29.083 14.613c1.559-2.56 5.275-2.56 6.834 0L56.799 48.92c1.623 2.666-.296 6.08-3.416 6.08H11.617c-3.12 0-5.039-3.414-3.416-6.08l20.882-34.307Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#132B3E",
    d: "M32.704 26c1.063 0 1.917.873 1.894 1.935l-.253 11.824a1.644 1.644 0 0 1-3.288-.001l-.247-11.824A1.894 1.894 0 0 1 32.704 26ZM32.7 48c-.607 0-1.127-.227-1.56-.68-.427-.454-.64-1.006-.64-1.658 0-.638.213-1.183.64-1.637.433-.453.953-.68 1.56-.68.593 0 1.107.227 1.54.68.44.454.66 1 .66 1.637 0 .432-.103.825-.31 1.18-.2.354-.467.637-.8.85A2.01 2.01 0 0 1 32.7 48Z"
  })));
};

export { SvgWarningIconTriangle as ReactComponent };
export default "/_next/static/media/warning_icon_triangle.c9cd7160.svg";